module.exports = __webpack_public_path__ + "static/media/5.1.d5f12456.png";